import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import MainPage       from './pages/Main/MainPage';
import LoginPage      from './pages/Login/LoginPage';
import DashboardPage  from './pages/Dashboard/DashboardPage';
import ProtectedRoute from './routes/ProtectedRoute';
import { ROUTES }     from './constants/api';

import './App.css';

/* ------------------------------------------------------------------
   App — routing root
------------------------------------------------------------------ */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path={ROUTES.MAIN} element={<MainPage />} />
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />

        {/* Protected routes */}
        <Route
          path={ROUTES.DASHBOARD}
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to={ROUTES.MAIN} replace />} />
      </Routes>
    </BrowserRouter>
  );
}
